import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, injectIntl} from 'react-intl';
import {Field, reduxForm} from 'redux-form';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';
import FieldCheckbox from '../fields/fieldCheckbox/FieldCheckbox';

@injectIntl
@reduxForm({
  form: 'signUp',
  validate: ({password = '', passwordRepeated = '', tosAccepted}) => ({
    password: password.length >= 4 ? undefined : <FormattedMessage id="section.auth.password.short"/>,
    passwordRepeated: password === passwordRepeated ? undefined : <FormattedMessage id="section.auth.password.must-match"/>,
    tosAccepted: tosAccepted ? undefined : <FormattedMessage id="section.auth.accept-tos"/>
  })
})
export default class SignUpForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="email"
          type="email"
          placeholder={intl.formatMessage({id: 'section.generic.email'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="password"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.title'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="passwordRepeated"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.repeat'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="tosAccepted"
          component={FieldCheckbox}
        >
          <FormattedMessage id="section.tos.agree"/>
          {' '}
          <a href="/page/terms-of-service" target="_blank">
            <FormattedMessage id="section.tos.terms"/>
          </a>
          {' '}
          <FormattedMessage id="section.tos.and"/>
          {' '}
          <a href="/page/privacy-policy" target="_blank">
            <FormattedMessage id="section.tos.privacy-policy"/>
          </a>
        </Field>

        <Field
          name="newsletterSubscribed"
          component={FieldCheckbox}
        >
          <FormattedMessage id="section.subscribe"/>
        </Field>

        <Button full filled loading={submitting} disabled={submitting}>
          <FormattedMessage id="section.auth.sign-up.action"/>
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/SignUpForm.js